import { z } from 'zod';

// ─── Hackathon Brand Names ──────────────────────────────────────────────────

export const HACKATHON_BRAND_NAMES = [
  'Elderberry',
  'Banana',
  'Fig',
  'Honeydew',
  'Apple',
  'Kiwi',
  'Lemon',
  'Grape',
  'Cherry',
  'Quince',
  'Nectarine',
  'Date',
  'Mango',
  'Orange',
  'Papaya',
  'Strawberry',
  'Blueberry',
] as const;

export const HackathonBrandNameEnum = z.enum(HACKATHON_BRAND_NAMES);

export type HackathonBrandName = z.infer<typeof HackathonBrandNameEnum>;

// ─── Hackathon Segment Names ────────────────────────────────────────────────

export const HACKATHON_SEGMENT_NAMES = [
  'Elderberry Dabbler',
  'Elderberry Dominant',
  'Grape Adopter',
  'Defender of Banana + Fig + Lemon',
  'Doublet Disciple',
] as const;

export const SegmentNameEnum = z.enum(HACKATHON_SEGMENT_NAMES);

export type SegmentName = z.infer<typeof SegmentNameEnum>;

// ─── Hackathon Clinical Trials ───────────────────────────────────────────────

export const HACKATHON_CLINICAL_TRIALS = ['CEPHEUS', 'MAIA', 'PERSEUS'] as const;

export const HackathonClinicalTrialEnum = z.enum(HACKATHON_CLINICAL_TRIALS);

export type HackathonClinicalTrial = z.infer<typeof HackathonClinicalTrialEnum>;
